import AboutModal from './AboutModal.json';
import AdvancedFilters from './AdvancedFilters.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DataSourceConfiguration from './DataSourceConfiguration.json';
import DatePicker from './DatePicker.json';
import ErrorBoundary from './ErrorBoundary.json';
import Feedback from './Feedback.json';
import Header from './Header.json';
import HotkeysValidators from './HotkeysValidators.json';
import Invite from './Invite.json';
import Login from './Login.json';
import MeasurementTable from './MeasurementTable.json';
import Messages from './Messages.json';
import Modes from './Modes.json';
import NotFound from './NotFound.json';
import ProcessingErrors from './ProcessingErrors.json';
import SegmentationTable from './SegmentationTable.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyItem from './StudyItem.json';
import StudyList from './StudyList.json';
import TooltipClipboard from './TooltipClipboard.json';
import ThumbnailTracked from './ThumbnailTracked.json';
import TrackedCornerstoneViewport from './TrackedCornerstoneViewport.json';
import Upload from './Upload.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import Workspaces from './Workspaces.json';

export default {
  'pt-BR': {
    AboutModal,
    AdvancedFilters,
    Buttons,
    CineDialog,
    Common,
    DataSourceConfiguration,
    DatePicker,
    ErrorBoundary,
    Feedback,
    Header,
    HotkeysValidators,
    Invite,
    Login,
    MeasurementTable,
    Messages,
    Modes,
    NotFound,
    ProcessingErrors,
    SegmentationTable,
    SidePanel,
    StudyBrowser,
    StudyItem,
    StudyList,
    TooltipClipboard,
    ThumbnailTracked,
    TrackedCornerstoneViewport,
    Upload,
    UserPreferencesModal,
    ViewportDownloadForm,
    Workspaces,
  },
};
